
import Api from '@/common/api';
import ApiHelper from '@/common/ApiHelper';
import { TLang } from '@/utils/lang';
import DFWebUtilsTools from '@df-fe/df-web-utils-tools';
import { unionFlag, getSessonStorage, setLocalStorage, getAddressReturn, setCookie, getLocalStorage, setSessonStorage, getQueryString, checkUnifyShop, transformCities } from '@/utils';
import { safeJsonParse } from '@/utils/safeJsonParse';

const api = new ApiHelper();

const MALLAPI_URL = process.env.MALLAPI_URL;
const APPAPI_URL = process.env.APPAPI_URL;
const BFDAPI_URL = process.env.BFDAPI_URL;
const homeUrl = {
  getunionconfig: MALLAPI_URL + '/union/getunionconfig',
  getLogo: MALLAPI_URL + '/mallunion/getLogo',
  getcitylist: '/df-gw/location/area/getcitylist',
  getDefaultAddr: APPAPI_URL + '/trade/addressContract/getDefaultAddress',
  getCheckLogin: MALLAPI_URL + '/user/checkLogin',
  getUnionMenuList: APPAPI_URL + '/mallUnion/unionMallConfig/findUsableList',
  getUnionMenuListNew: APPAPI_URL + '/mallUnion/unionMallConfig/findMallNaviConfig',
  findByUnionUrl: APPAPI_URL + '/mallUnion/unionConfig/findByUnion',
  signature: APPAPI_URL + '/permission_valid_config/signature',
  getUnionConfUrl: BFDAPI_URL + '/backend/getUnionConf'
};
const localAddress = safeJsonParse(DFWebUtilsTools.getCatchAddress());

const SUCCESS = '00000000';
const homeReq = {
  homeUrl,
  GetDistrictData: () => Api.getCinemaDistrictCount(''),
  /** 获取百福德相关数据 */
  getUnionConfig: () => {

    const unionCode = unionFlag() || getSessonStorage('dffl_union');
    if (!checkUnifyShop()) {
      if (!unionCode && unionCode === 'null') {
        return null;
      }
    }
    setSessonStorage('dffl_union', unionCode);
    let params = {
      unionFlag: unionCode ? 1 : 0,
      union: unionCode
    };
    return api.Post(homeUrl.getunionconfig, params, true).then((res: any) => {
      let response = res.Data;
      if (response.respCode && response.respCode === SUCCESS) {
        return {
          union_scale: response.scale || 1,
          union_icon: response.icon || '',
          union_name: response.name || TLang('福豆', 'card')

        };
      } else {
        return null;
      }
    });
  },

  /** 获取百福德新接口相关数据 */
  getUnionNewConfig: () => {
    const unionCode = unionFlag() || getSessonStorage('dffl_union');
    if (!checkUnifyShop()) {
      if (!unionCode && unionCode === 'null') {
        return null;
      }
    }
    setSessonStorage('dffl_union', unionCode);
    let params = {
      unionFlag: unionCode ? 1 : 0,
      union: unionCode
    };

    return api.Post(homeUrl.getUnionConfUrl, params, true).then((res: any) => {
      let response = res.Data;
      if (response.success && response.data) {
        return {
          hamburgerSwitch: response.data.hamburgerSwitch || 0,
          showHomePage: response.data.showHomePage || false
        };
      } else {
        return null;
      }
    });
  },

  /** 初始化百福德基础数据 */
  getLogo: () => {
    const unionCode = unionFlag() || getSessonStorage('dffl_union');
    if (!checkUnifyShop()) {
      if (!unionCode || unionCode === 'null') {
        return null;
      }
    }
    const params = {
      union: unionCode
    };
    return api.Post(homeUrl.getLogo, params, true).then(({ Data }) => ({
      logo: Data.h5ShopLogo || Data.logo || '',
      h5HomeIndex: Data.h5HomeIndex || '',
      h5ShoppingCart: Data.h5ShoppingCart || '',
      h5UserCenter: Data.h5UserCenter || ''
    }));
  },
  getCityList: (cityId) =>
    api.Post(homeUrl.getcitylist, {
      platform: 1,
      cityId,
      city: '',
      ignore: false
    }).then((res: any) => {
      const { Status, Data } = res || {};
      const { data } = Data || {};
      const { cityList=[], historyCities=[], hotCities=[] } = data || {};
      if (Status && Status === 'BFF000000') {
        return {
          ...data,
          cityList:transformCities(cityList),
          historyCities:transformCities(historyCities),
          hotCities:transformCities(hotCities)
        };
      } else {
        return null;
      }
    })
  ,
  getDefaultAddress: (param) => api.Post(homeUrl.getDefaultAddr, param, false).then((res: any) => {
    // console.log(res);
    if (res.Data && res.Status == '0') {
      return res.Data;
    } else {
      return res;
    }
  }),
  //   platform: 1
  // cityId: 145
  // city: 145
  // ignore: false
  // unionFlag: 0
  getLoginStatus: (data = {}) => {
    const address: any = getSessonStorage('currentAddress');
    return api.Post(homeUrl.getCheckLogin, {
      city: localAddress && localAddress?.cityId ? localAddress?.cityId : address?.cityId || '145',
      ignore: false,
      ...data
    }, true).then((res: any) => {
      let response = res.Data;
      if (response.respCode && response.respCode === SUCCESS) {
        return response;
      } else {
        return null;
      }
    });
  },
  getLoginStatus2: (data = {}) => {
    const address: any = getSessonStorage('currentAddress');
    return api.Post(homeUrl.getCheckLogin, {
      city: localAddress && localAddress?.cityId ? localAddress?.cityId : address?.cityId || '145',
      ignore: false,
      ...data
    }, true);
  },
  getMenuList: () => {
    const unionCode = unionFlag() || getSessonStorage('dffl_union');
    if (!checkUnifyShop()) {
      if (!unionCode && unionCode === 'null') {
        return null;
      }
    }
    setSessonStorage('dffl_union', unionCode);
    let params = {
      unionFlag: unionCode ? 1 : 0,
      union: unionCode,
      platform: 1,
      baseChannelNo: 1
    };
    return api.Post(homeUrl.getUnionMenuListNew, params).then(({ Data }) =>
    // console.log('getMenuList',Data)
    ({
      menuItems: Data
    })
    );
  },
  findByUnion: () => {
    const unionCode = unionFlag() || getSessonStorage('dffl_union');
    if (!checkUnifyShop()) {
      if (!unionCode && unionCode === 'null') {
        return null;
      }
    }
    setSessonStorage('dffl_union', unionCode);
    let params = {
      unionFlag: unionCode ? 1 : 0,
      union: unionCode
    };
    return api.Post(homeUrl.findByUnionUrl, params).then(({ Data }) => ({
      Data
    }));

  },
  getWXAuth: () => {
    // 1 微信 ; 2 企业微信
    const type = navigator.userAgent.match(/wxwork/i) ? 2 : 1;
    return api.Post(homeUrl.signature, { caller: type, url: window.location.href.split('#')[0] }).then(({ Data }) => ({
      Data
    }));
  }
};
export default homeReq;
